import DateTimeCell from './DateTimeCell';
import React from 'react';
import TermInfoDrawer from './TermInfoDrawer';
import { getDisplayStatus } from '../../../utilities/displayFunctions';
import Button from '../../common/Button';
import StatusCell from './StatusCell';
import TermStatus from '../../../constants/termStatus';
import NameCell from './NameCell';
import MultiSelectCell from './MultiSelectCell';
import AgreementTypeLabel from '../../contracts/createContract/SetupShippingPricingTermStep/AgreementTypeLabel';
import ActionsCell from './ActionsCell';

const sortCaseInsensitive = (row, column) => {
  return row[column.value] && row[column.value].toLowerCase();
};

const createContractColumns = ({ t, selectMultipleTerms = false }) => {
  const multiSelectHeader = {
    id: 'multiSelect',
    Header: props => <MultiSelectCell selectAll {...props} />,
    accessor: t => t.additionalData && t.additionalData.name,
    sortable: false,
    Cell: props => <MultiSelectCell {...props} />
  };

  const columns = [
    {
      id: 'name',
      Header: t('common:commonTerminology.name'),
      accessor: t => t.additionalData && t.additionalData.name,
      sortable: true,
      onSort: sortCaseInsensitive,
      Cell: ({ original, value }) => (
        <NameCell original={original} value={value} selectMultipleTerms={selectMultipleTerms} />
      )
    },
    {
      id: 'agreementType',
      Header: t('common:commonTerminology.contractType'),
      accessor: t => t,
      sortable: true,
      Cell: props => <AgreementTypeLabel t={t} term={props.value} />
    },
    {
      id: 'seller',
      Header: t('common:commonTerminology.seller'),
      accessor: t => t.seller.name,
      sortable: true,
      onSort: sortCaseInsensitive
    },
    {
      id: 'buyer',
      Header: t('common:commonTerminology.buyer'),
      accessor: t => t.buyer.name,
      sortable: true,
      onSort: sortCaseInsensitive
    },
    {
      Header: 'Status',
      accessor: t('common:commonTerminology.status'),
      sortable: true,
      Cell: props => (
        <div>
          <StatusCell term={props.original} />
          {props.original.previousRevision &&
            (props.original.status === TermStatus.PENDING ||
              (props.original.isEffective && props.original.status === TermStatus.REJECTED)) && (
              <TermInfoDrawer
                termRevision={props.original.previousRevision}
                latestRevisionId={props.original.revisionId}>
                <Button bsStyle="link">
                  <small>
                    {
                      getDisplayStatus({
                        contractRevision: props.original.previousRevision,
                        hasAcceptorPermission: props.original.userHasAuthorizationFor.acceptor,
                        isPriorTerm: true
                      }).displayStatus
                    }
                  </small>
                </Button>
              </TermInfoDrawer>
            )}
        </div>
      )
    },
    {
      id: 'createdAt',
      Header: t('common:commonTerminology.lastUpdated'),
      accessor: 'createdAt',
      sortable: true,
      Cell: props => <DateTimeCell timestamp={props.value} />
    },
    {
      id: 'actions',
      Header: t('common:commonTerminology.actions'),
      sortable: false,
      Cell: props => <ActionsCell term={props.original} />
    },
    // hidden field to use just for filtering purpose
    {
      accessor: 'isEffective',
      show: false
    }
  ];

  return selectMultipleTerms ? [multiSelectHeader, ...columns] : columns;
};

export default createContractColumns;
